module.exports = __webpack_public_path__ + "static/media/savio-rozhovor.b668f216.jpg";